import { render, staticRenderFns } from "./QuotesPage.vue?vue&type=template&id=526507b4&"
import script from "./QuotesPage.vue?vue&type=script&lang=js&"
export * from "./QuotesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports